var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedulePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.92,
    height: 106.163,
    viewBox: "0 0 129.92 106.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.686,
    y1: 0.091,
    x2: -1.409,
    y2: 2.41,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#17161f",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#343247",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.564,
    y1: -0.253,
    x2: 0.517,
    y2: 0.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.769
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.599,
    y1: 4.112,
    x2: 0.416,
    y2: -2.554,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.268,
    y1: 0.499,
    x2: -7.539,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#292838",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5.408,
    y1: 0.499,
    x2: -11.239,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#67ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5cb3ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#538ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4c718b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#465a73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#424a63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#404059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.472,
    y1: 0.08,
    x2: 0.639,
    y2: 2.614,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.472,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.477,
    y1: 0.08,
    x2: 0.643,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.473,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.472,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.477,
    y1: 0.08,
    x2: 0.643,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.473,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1.255,
    y1: 0.72,
    x2: -0.438,
    y2: 0.295,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#edcbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 0.502,
    x2: 1,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.001,
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.196,
    y1: 0.676,
    x2: -1.453,
    y2: 2.686,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.846,
    y1: -0.323,
    x2: 0.242,
    y2: 0.981,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1.265,
    y1: 0.585,
    x2: -0.551,
    y2: 0.349,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2.509,
    y1: -0.84,
    x2: -1.815,
    y2: 1.582,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.974,
    y1: -1.234,
    x2: -0.513,
    y2: 1.608,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.477,
    y1: 0.275,
    x2: 1.968,
    y2: 0.795,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.309,
    y1: -0.199,
    x2: 1.045,
    y2: 2.495,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.506,
    y1: -0.783,
    x2: 0.488,
    y2: 2.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.286,
    y1: -0.433,
    x2: 1.588,
    y2: 1.675,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48343",
    "data-name": "Group 48343",
    transform: "translate(-0.002 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94666",
    "data-name": "Path 94666",
    d: "M28.213,22.679c-7.677,4.1-15.586,8.395-20.937,15.262A35.471,35.471,0,0,0,.794,52.1c-1.931,8.729-.5,18.849,6.142,24.852a25.825,25.825,0,0,0,8.055,4.718A43.211,43.211,0,0,0,34,84.488c5.312-.414,10.614-1.814,15.9-1.147,6.446.811,12.074,4.581,18.079,7.063a47.2,47.2,0,0,0,23.6,3.219,15.768,15.768,0,0,0,5.841-1.631c2.109-1.179,3.672-3.1,5.335-4.865A46.545,46.545,0,0,1,115.818,77.4c2.566-1.284,5.285-2.349,7.513-4.156C129.2,68.5,130.2,60,129.863,52.468s-2.04-15.851-8.07-20.426c-1.346-1.021-2.861-1.812-4.166-2.888-4.353-3.588-5.655-9.6-8.443-14.5C102.932,3.67,88.981-1.137,76.422.222,58.425,2.169,43.685,14.416,28.213,22.679Z",
    transform: "translate(0 0)",
    fill: "#68e1fd",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94667",
    "data-name": "Path 94667",
    d: "M587.956,240.61c-.164,1.512-2.029,4.049-4.609,6.9a181.53,181.53,0,0,1-14.067,13.376h0c-1.906,1.655-3.16,2.7-3.16,2.7V234.861s4.474-5.729,7.725-6.1,9.81,3.434,9.81,3.434S588.5,235.354,587.956,240.61Z",
    transform: "translate(-465.45 -188.066)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94668",
    "data-name": "Path 94668",
    d: "M595.983,282.11a181.532,181.532,0,0,1-14.067,13.376,3.314,3.314,0,0,1-.356-1.577c-.1-2.7-.075-5.406-.05-8.109.023-2.625.046-5.247.212-7.867a17.98,17.98,0,0,1,1.572-7.113,2.727,2.727,0,0,1,.614.8,41.269,41.269,0,0,1,3.185,7.728q.66,1.956,1.319,3.928a9.424,9.424,0,0,0,2.6-2.107c.676-.749,1.279-1.558,1.9-2.351.434-.555,1.28-2.134,1.956-1.54C595.963,278.23,596.052,280.415,595.983,282.11Z",
    transform: "translate(-478.086 -222.664)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24248",
    "data-name": "Rectangle 24248",
    width: 72.834,
    height: 84.353,
    transform: "translate(31.12 8.974)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24249",
    "data-name": "Rectangle 24249",
    width: 72.834,
    height: 84.353,
    transform: "translate(31.12 8.974)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94669",
    "data-name": "Path 94669",
    d: "M237.824,54.557,175,60.189c.283,0,0-7.824,0-9.709h66.239v.661A3.416,3.416,0,0,1,237.824,54.557Z",
    transform: "translate(-143.88 -41.506)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94714",
    "data-name": "Path 94714",
    d: "M0,0H72.834V84.353H0Z",
    transform: "translate(31.12 18.683)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24251",
    "data-name": "Rectangle 24251",
    width: 10.355,
    height: 84.353,
    transform: "translate(31.12 18.683)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24252",
    "data-name": "Rectangle 24252",
    width: 12.581,
    height: 12.581,
    transform: "translate(35.185 34.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24253",
    "data-name": "Rectangle 24253",
    width: 12.581,
    height: 12.581,
    transform: "translate(48.465 34.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24254",
    "data-name": "Rectangle 24254",
    width: 12.581,
    height: 12.581,
    transform: "translate(61.746 34.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24255",
    "data-name": "Rectangle 24255",
    width: 12.581,
    height: 12.581,
    transform: "translate(75.026 34.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24256",
    "data-name": "Rectangle 24256",
    width: 12.581,
    height: 12.581,
    transform: "translate(35.185 47.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24257",
    "data-name": "Rectangle 24257",
    width: 12.581,
    height: 12.581,
    transform: "translate(48.465 47.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24258",
    "data-name": "Rectangle 24258",
    width: 12.581,
    height: 12.581,
    transform: "translate(61.746 47.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24259",
    "data-name": "Rectangle 24259",
    width: 12.581,
    height: 12.581,
    transform: "translate(75.026 47.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24260",
    "data-name": "Rectangle 24260",
    width: 12.581,
    height: 12.581,
    transform: "translate(35.185 60.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24261",
    "data-name": "Rectangle 24261",
    width: 12.581,
    height: 12.581,
    transform: "translate(48.465 60.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24262",
    "data-name": "Rectangle 24262",
    width: 12.581,
    height: 12.581,
    transform: "translate(61.746 60.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24263",
    "data-name": "Rectangle 24263",
    width: 12.581,
    height: 12.581,
    transform: "translate(75.026 60.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24264",
    "data-name": "Rectangle 24264",
    width: 12.581,
    height: 12.581,
    transform: "translate(35.185 73.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24265",
    "data-name": "Rectangle 24265",
    width: 12.581,
    height: 12.581,
    transform: "translate(48.465 73.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24266",
    "data-name": "Rectangle 24266",
    width: 12.581,
    height: 12.581,
    transform: "translate(61.746 73.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24267",
    "data-name": "Rectangle 24267",
    width: 12.581,
    height: 12.581,
    transform: "translate(75.026 73.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24268",
    "data-name": "Rectangle 24268",
    width: 12.581,
    height: 12.581,
    transform: "translate(35.185 86.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24269",
    "data-name": "Rectangle 24269",
    width: 12.581,
    height: 12.581,
    transform: "translate(48.465 86.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24270",
    "data-name": "Rectangle 24270",
    width: 12.581,
    height: 12.581,
    transform: "translate(61.746 86.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24271",
    "data-name": "Rectangle 24271",
    width: 12.581,
    height: 12.581,
    transform: "translate(88.083 34.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24272",
    "data-name": "Rectangle 24272",
    width: 12.581,
    height: 12.581,
    transform: "translate(88.083 21.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24273",
    "data-name": "Rectangle 24273",
    width: 12.581,
    height: 12.581,
    transform: "translate(75.026 21.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24274",
    "data-name": "Rectangle 24274",
    width: 12.581,
    height: 12.581,
    transform: "translate(88.083 47.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24275",
    "data-name": "Rectangle 24275",
    width: 12.581,
    height: 12.581,
    transform: "translate(88.083 60.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24276",
    "data-name": "Rectangle 24276",
    width: 12.581,
    height: 12.581,
    transform: "translate(88.083 73.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94670",
    "data-name": "Path 94670",
    d: "M206.73,28.217v6.821c0,.368.468.667,1.042.667h0c.576,0,1.042-.3,1.042-.667V28.217c0-.368-.466-.667-1.042-.667h0C207.2,27.55,206.73,27.849,206.73,28.217Z",
    transform: "translate(-169.968 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94671",
    "data-name": "Path 94671",
    d: "M262.75,28.217v6.821c0,.368.466.667,1.042.667h0c.576,0,1.042-.3,1.042-.667V28.217c0-.368-.466-.667-1.042-.667h0C263.216,27.55,262.75,27.849,262.75,28.217Z",
    transform: "translate(-216.026 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94672",
    "data-name": "Path 94672",
    d: "M318.77,28.217v6.821c0,.368.466.667,1.042.667h0c.576,0,1.042-.3,1.042-.667V28.217c0-.368-.466-.667-1.042-.667h0C319.236,27.55,318.77,27.849,318.77,28.217Z",
    transform: "translate(-262.085 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94673",
    "data-name": "Path 94673",
    d: "M374.79,28.217v6.821c0,.368.466.667,1.042.667h0c.574,0,1.042-.3,1.042-.667V28.217c0-.368-.468-.667-1.042-.667h0C375.256,27.55,374.79,27.849,374.79,28.217Z",
    transform: "translate(-308.143 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94674",
    "data-name": "Path 94674",
    d: "M430.8,28.217v6.821c0,.368.468.667,1.044.667h0c.574,0,1.042-.3,1.042-.667V28.217c0-.368-.468-.667-1.042-.667h0C431.268,27.55,430.8,27.849,430.8,28.217Z",
    transform: "translate(-354.193 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94675",
    "data-name": "Path 94675",
    d: "M486.82,28.217v6.821c0,.368.468.667,1.042.667h0c.576,0,1.044-.3,1.044-.667V28.217c0-.368-.468-.667-1.044-.667h0C487.288,27.55,486.82,27.849,486.82,28.217Z",
    transform: "translate(-400.252 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94676",
    "data-name": "Path 94676",
    d: "M541.64,28.217v6.821c0,.368.468.667,1.042.667h0c.576,0,1.042-.3,1.042-.667V28.217c0-.368-.466-.667-1.042-.667h0C542.108,27.55,541.64,27.849,541.64,28.217Z",
    transform: "translate(-445.323 -22.653)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24277",
    "data-name": "Rectangle 24277",
    width: 1.657,
    height: 94.062,
    transform: "translate(103.956 8.974)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94677",
    "data-name": "Path 94677",
    d: "M428.992,125.629a1,1,0,1,1-1-1A1,1,0,0,1,428.992,125.629Z",
    transform: "translate(-351.061 -102.47)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94678",
    "data-name": "Path 94678",
    d: "M428.992,199.5a1,1,0,1,1-1-1A1,1,0,0,1,428.992,199.5Z",
    transform: "translate(-351.061 -163.205)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94679",
    "data-name": "Path 94679",
    d: "M442.742,199.5a1,1,0,1,1-1-1A1,1,0,0,1,442.742,199.5Z",
    transform: "translate(-362.365 -163.205)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94680",
    "data-name": "Path 94680",
    d: "M456.572,199.5a1,1,0,1,1-1-1A1,1,0,0,1,456.572,199.5Z",
    transform: "translate(-373.736 -163.205)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94681",
    "data-name": "Path 94681",
    d: "M428.992,348.271a1,1,0,1,1-.292-.708A1,1,0,0,1,428.992,348.271Z",
    transform: "translate(-351.061 -285.52)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1261",
    "data-name": "Ellipse 1261",
    cx: 0.999,
    cy: 0.999,
    r: 0.999,
    transform: "translate(36.298 61.752)",
    fill: "#ff2235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94682",
    "data-name": "Path 94682",
    d: "M442.742,348.271a1,1,0,1,1-.292-.708A1,1,0,0,1,442.742,348.271Z",
    transform: "translate(-362.366 -285.52)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94683",
    "data-name": "Path 94683",
    d: "M456.572,348.271a1,1,0,1,1-.292-.708A1,1,0,0,1,456.572,348.271Z",
    transform: "translate(-373.736 -285.52)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94684",
    "data-name": "Path 94684",
    d: "M643.936,176.884c-.279,1.142.094,2.724-.436,3.772-.889,1.76-3.489,2.929-3.873,4.862-.023.112-2.916,1.506-4.408,1.03-.781-.247-1.177-1.008-.576-2.73.188-.533,1.245-.733,1.529-1.229l-.059-.044c-1.444-1.09-1.6-3.4-1.3-4.942a16.653,16.653,0,0,1,1.718-4.431,3.39,3.39,0,0,1,3.066-1.654,4.67,4.67,0,0,1,3.962,1.956A4.533,4.533,0,0,1,643.936,176.884Z",
    transform: "translate(-521.549 -141.02)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94685",
    "data-name": "Path 94685",
    d: "M635.922,152.416a4.253,4.253,0,0,1-2.507.774,1.193,1.193,0,0,0,.5,1.1l-.548.123a.149.149,0,0,0-.114.064.146.146,0,0,0,.012.121,1.8,1.8,0,0,0,.638.777c-.1.21-.452.164-.573.356a.429.429,0,0,0,0,.365,1.973,1.973,0,0,0,.6.848.769.769,0,0,0,.329,1.175.946.946,0,0,0,1.149-.6.949.949,0,0,1-.135.589,7.779,7.779,0,0,0,4.46-.178,1.169,1.169,0,0,0-.1.452,2.148,2.148,0,0,0,1.024.064,5.933,5.933,0,0,1-.194,2.18c-.123.441-.3.868-.377,1.318a1.789,1.789,0,0,0,.226,1.321.672.672,0,0,0,.494-.462,2.381,2.381,0,0,1,.293-.644.9.9,0,0,1,1.382.2,1.531,1.531,0,0,1-.1,1.543,2.345,2.345,0,0,1-1.536,1.067c.052.5.1.992.156,1.487.937-.889,1.986-1.652,2.829-2.625a4.9,4.9,0,0,0,1.373-3.5c-.066-.791-.411-1.543-.437-2.338-.012-.356.041-.72.027-1.079a2.927,2.927,0,0,0-1.929-2.584,5.826,5.826,0,0,1-1.355-.461c-.5-.324-.759-.926-1.255-1.257a7.423,7.423,0,0,0-1.983-.678A3.312,3.312,0,0,0,635.922,152.416Z",
    transform: "translate(-520.64 -124.856)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94686",
    "data-name": "Path 94686",
    d: "M584.245,246.691a.533.533,0,0,0-.245.356.356.356,0,0,0,.286.317,1.048,1.048,0,0,0,.457-.021l.9-.178a3.087,3.087,0,0,0-1.172,1.156.334.334,0,0,0,.016.365c.121.153.325.092.489.028l.784-.313-.534.517a2.421,2.421,0,0,0-.43.505,1.047,1.047,0,0,0-.114.283A.247.247,0,0,0,585,250a2.392,2.392,0,0,0,.889-.469,6.048,6.048,0,0,1-.642.759,1.277,1.277,0,0,0-.37.889.178.178,0,0,0,.034.1.164.164,0,0,0,.1.046,1.017,1.017,0,0,0,.772-.356l.806-.731a1.8,1.8,0,0,0,.34-.368.507.507,0,0,0,.087-.269.356.356,0,0,0-.546-.269c.023-.155.083-.3.121-.45a.637.637,0,0,0-.029-.452.308.308,0,0,0-.391-.148,1.72,1.72,0,0,0,.178-.592.571.571,0,0,0-.261-.533.405.405,0,0,1-.132-.084c-.071-.087-.014-.212.016-.32a.517.517,0,0,0-.534-.692A2.325,2.325,0,0,0,584.245,246.691Z",
    transform: "translate(-480.151 -202.306)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94687",
    "data-name": "Path 94687",
    d: "M606.992,283.383c2.045-1.807,4.577-.437,3.688,2.143-1.922,5.582-5.946,18.371-9.768,18.371-4.979,0-6.992-8.829-6.992-8.829l2.3-4.654s3.252,7.136,4.89,5.2,2.605-9.247,5.788-12.152Z",
    transform: "translate(-488.307 -232.317)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94688",
    "data-name": "Path 94688",
    d: "M592.539,295.689a11.1,11.1,0,0,1-.021-1.245,9.38,9.38,0,0,0-1.54-5.095.736.736,0,0,0-.126.516l.027,4.723a5.47,5.47,0,0,1-.078,1.17c-.06.281-.164.549-.244.827a4.865,4.865,0,0,0-.178,1.778,2.161,2.161,0,0,0,.254.919,1.024,1.024,0,0,0,.768.519c.1,0,.533-.889.6-1.01q.285-.533.534-1.076c.123-.274.384-.677.338-.985C592.817,296.386,592.582,296.068,592.539,295.689Z",
    transform: "translate(-485.381 -237.899)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94689",
    "data-name": "Path 94689",
    d: "M638.21,234.8c-.43.484-.857.969-1.287,1.455a5.1,5.1,0,0,1-1.159,1.067,2.342,2.342,0,0,1-.544.235c-.781-.247-1.177-1.008-.576-2.73.188-.533,1.245-.733,1.529-1.229l-.059-.044a2.689,2.689,0,0,0,.642.21c.462.069,1.6-.29,1.741.395A.784.784,0,0,1,638.21,234.8Z",
    transform: "translate(-521.549 -192.022)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94690",
    "data-name": "Path 94690",
    d: "M364.919,432.6l1.792,2.785a.557.557,0,0,0,.889.062l4.936-5.69a.555.555,0,0,0-.418-.919h-.041a.557.557,0,0,0-.427.2l-3.862,4.63a.553.553,0,0,1-.889-.052l-1.051-1.6a.555.555,0,0,0-.548-.244h0a.553.553,0,0,0-.382.829Z",
    transform: "translate(-299.963 -352.585)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94691",
    "data-name": "Path 94691",
    d: "M221.283,510.535l2.257,2.221a.562.562,0,0,1-.395.962h-.1a.567.567,0,0,1-.4-.164l-2.2-2.2a.564.564,0,0,0-.795,0l-2.2,2.2a.562.562,0,0,1-.4.164h-.1a.562.562,0,0,1-.395-.962l2.258-2.221a.56.56,0,0,0,0-.8l-2.28-2.28a.562.562,0,0,1,.4-.958h0a.558.558,0,0,1,.393.16l2.312,2.28a.562.562,0,0,0,.788,0l2.312-2.28a.558.558,0,0,1,.393-.16h0a.562.562,0,0,1,.4.958l-2.28,2.28a.56.56,0,0,0,.018.8Z",
    transform: "translate(-177.909 -416.435)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94692",
    "data-name": "Path 94692",
    d: "M130.74,489.92h.551l.276,12.458-.276-2.052h-.551Z",
    transform: "translate(-107.49 -402.804)",
    fill: "#9f95df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24278",
    "data-name": "Rectangle 24278",
    width: 0.551,
    height: 10.406,
    transform: "translate(23.801 87.116)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94693",
    "data-name": "Path 94693",
    d: "M131.64,520.81",
    transform: "translate(-108.23 -428.201)",
    fill: "#607c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94694",
    "data-name": "Path 94694",
    d: "M108.359,497.932c-.311.962.672,2.866,1.625,3.852s1.6.759,2.571.478c.311-.962.576-1.618-.379-2.6S109.33,497.651,108.359,497.932Z",
    transform: "translate(-89.041 -409.352)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94695",
    "data-name": "Path 94695",
    d: "M138.408,498.146c-.962-.313-2.866.672-3.852,1.625s-.759,1.6-.478,2.571c.962.311,1.618.576,2.6-.379S138.691,499.117,138.408,498.146Z",
    transform: "translate(-110.037 -409.519)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94696",
    "data-name": "Path 94696",
    d: "M122.461,475.79H120c0,1.748,1.1,3.165,2.459,3.165l.58-1.552Z",
    transform: "translate(-98.66 -391.186)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94697",
    "data-name": "Path 94697",
    d: "M133.84,475.79H136.3c0,1.748-1.1,3.165-2.459,3.165Z",
    transform: "translate(-110.039 -391.186)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94698",
    "data-name": "Path 94698",
    d: "M107.369,455.521c-.311.962.672,2.868,1.627,3.852s1.6.761,2.57.478c.311-.962.576-1.618-.379-2.6S108.34,455.241,107.369,455.521Z",
    transform: "translate(-88.227 -374.483)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94699",
    "data-name": "Path 94699",
    d: "M137.426,455.729c-.964-.311-2.868.672-3.852,1.627s-.761,1.6-.48,2.57c.962.311,1.62.576,2.6-.379S137.707,456.7,137.426,455.729Z",
    transform: "translate(-109.229 -374.644)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94700",
    "data-name": "Path 94700",
    d: "M125.912,438.73c-.91.441-1.6,2.468-1.657,3.839a4.232,4.232,0,0,0,1.526,3.491c.91-.441,1.474-2.006,1.526-3.379S126.787,439.237,125.912,438.73Z",
    transform: "translate(-102.156 -360.716)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94701",
    "data-name": "Path 94701",
    d: "M106.49,538.606l.868,7.013h4.013l1.64-3.99-1.64-3.219Z",
    transform: "translate(-87.552 -442.671)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94702",
    "data-name": "Path 94702",
    d: "M138.823,538.606l-.868,7.013H133.94V538.41Z",
    transform: "translate(-110.121 -442.671)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94703",
    "data-name": "Path 94703",
    d: "M107.857,529.817l-.044.021-1.362.676-.372.188h-5.422a.617.617,0,0,1-.617-.617v-1.568a.617.617,0,0,1,.617-.617h5.422Z",
    transform: "translate(-82.249 -434.03)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94704",
    "data-name": "Path 94704",
    d: "M.617,0H6.03V2.8H.617A.617.617,0,0,1,0,2.185V.617A.617.617,0,0,1,.617,0Z",
    transform: "translate(29.849 96.672) rotate(180)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94705",
    "data-name": "Path 94705",
    d: "M108.359,497.932c-.311.962.672,2.866,1.625,3.852s1.6.759,2.571.478c.311-.962.576-1.618-.379-2.6S109.33,497.651,108.359,497.932Z",
    transform: "translate(-89.041 -409.352)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94706",
    "data-name": "Path 94706",
    d: "M138.408,498.146c-.962-.313-2.866.672-3.852,1.625s-.759,1.6-.478,2.571c.962.311,1.618.576,2.6-.379S138.691,499.117,138.408,498.146Z",
    transform: "translate(-110.037 -409.519)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94707",
    "data-name": "Path 94707",
    d: "M136.265,478.419a2.742,2.742,0,0,1-2.425,2.65V478.36c.02.073.043.146.064.222C134.784,478.867,135.41,479.114,136.265,478.419Z",
    transform: "translate(-110.039 -393.299)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94708",
    "data-name": "Path 94708",
    d: "M107.369,455.521c-.311.962.672,2.868,1.627,3.852s1.6.761,2.57.478c.311-.962.576-1.618-.379-2.6S108.34,455.241,107.369,455.521Z",
    transform: "translate(-88.227 -374.483)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48342",
    "data-name": "Group 48342",
    transform: "translate(19.028 93.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94709",
    "data-name": "Path 94709",
    d: "M111.792,543.66v6.275h-4.015L107,543.66Z",
    transform: "translate(-107 -540.929)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94710",
    "data-name": "Path 94710",
    d: "M138.741,543.66l-.777,6.275H133.95V543.66Z",
    transform: "translate(-129.158 -540.929)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94711",
    "data-name": "Path 94711",
    d: "M140.019,528.917v1.568a.617.617,0,0,1-.617.617H134v-2.8h5.411A.617.617,0,0,1,140.019,528.917Z",
    transform: "translate(-129.199 -528.3)",
    fill: "url(#linear-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_94712",
    "data-name": "Path 94712",
    d: "M64.246,578.976l-10.2,1.956a.626.626,0,0,0,.13,1.245h115.2a.624.624,0,0,0,.087-1.245L154.6,579.061h-.085l-90.138-.089A.645.645,0,0,0,64.246,578.976Z",
    transform: "translate(-43.974 -476.019)",
    fill: "#1d2741",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94713",
    "data-name": "Path 94713",
    d: "M135.693,459.557c-.084.08-.164.153-.242.215-.855.7-1.481.448-2.361.164-.021-.076-.044-.149-.064-.222a1.929,1.929,0,0,1,.544-2.347c.983-.955,2.888-1.938,3.852-1.627C137.7,456.71,136.678,458.6,135.693,459.557Z",
    transform: "translate(-109.225 -374.653)",
    fill: "url(#linear-gradient-24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulePopup);
export default __webpack_public_path__ + "static/media/SchedulePopup.50250a24fd16be5a62e356a5758fac20.svg";
export { ForwardRef as ReactComponent };